import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import PropTypes from 'prop-types';
import { isPackingTerminal } from '../services/api/kiosk.service';

// Create a client
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Keep the same cache duration as the localStorage implementation (24 hours)
      staleTime: 24 * 60 * 60 * 1000,
      cacheTime: 30 * 60 * 1000, // How long to keep unused data in memory
      retry: 1,
      // Disabled by default - enable this if you want data to refresh when window regains focus
      refetchOnWindowFocus: false
    },
  },
});

export const QueryProvider = ({ children }) => {
  return (
    <QueryClientProvider client={queryClient}>
      {children}
      {!isPackingTerminal() && <ReactQueryDevtools initialIsOpen={false} />}
    </QueryClientProvider>
  );
};

QueryProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export default QueryProvider;
